import { fork, put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";

//Auth
import { auth, db } from "./../../firebase";

//Deps
import { actions } from "react-redux-form";

function* logLogout() {
  yield put({ type: ACTIONS.HIT_LOGS, filter: "logout" });
}

function* handleLogout(action) {
  /*

    LOGOUT

  */
  const { cUID } = action;

  //Use fork to block call until logout is pushed
  if (cUID !== "self") {
    yield fork(logLogout);
  }

  //Set pending to false when finished
  yield put(actions.setPending("forms.logout", true));

  yield auth.doLogout();
  yield db.doRemoveListeners();

  yield put({ type: ACTIONS.RESET_USER });
  yield put({ type: ACTIONS.RESET_APP });

  //Route back to root
  yield put({
    type: ACTIONS.RE_ROUTE,
    path: "/"
  });

  //Reset forms
  yield put({
    type: ACTIONS.HANDLE_FORMS,
    meta: { filter: "reset_all" }
  });

  yield put({
    type: ACTIONS.OPEN_SNACKBAR,
    payload: {
      variant: "success",
      message: `successfully logged out`
    }
  });

  //Set pending to false when finished
  yield put(actions.setPending("forms.logout", false));
}

export function* logoutSaga() {
  yield takeEvery(ACTIONS.SUBMIT_LOGOUT, handleLogout);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/logout.js